<template>
    <div class="recordList">
        <div v-if="planList.length">
            <PlanList
                :planList="planList"
                :userType="userType"
                :pageData="pageData"
            ></PlanList>
            <Pagination :pageData="pageData" @changePage="changeCurrent" v-show="pageData.total>pageData.pageSize"></Pagination>
        </div>
        <Add
            v-else
            path='/consultant/minestudent/main/planningContent/addFirstPlaning_A'
            name="暂无规划内容，现在"
        />
    </div>
</template>
<script>
import Add from '@/components/consultant/Add'
import PlanList from '@/components/consultant/planningContent/PlanList.vue'
import Pagination from '@/components/consultant/Pagination.vue'
export default {
    name: "recordList",
    components: {
        Add,
        PlanList,
        Pagination
    },
    data() {
        return {
            userType: 3,  //1学生，2家长 3咨询师
            planList:[],
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            },
            // planList: [{
            //     "id": 6,
            //     "lastId": 5,
            //     "studentId": 1,
            //     "interviewTheme": "规划内容1次调整",
            //     "interviewTime": "2020-12-31 16:32:23"
            // }, {
            //     "id": 5,
            //     "lastId": null,
            //     "studentId": 1,
            //     "interviewTheme": "初次规划",
            //     "interviewTime": "2020-12-31 16:31:37"
            // }],
        }
    },
    created() {
        this.getPlanList();
    },
    methods: {
        changeCurrent(value) {
            this.pageData.current = value;
            this.getPlanList();
        },
        // 获取成绩列表
        getPlanList(){
            let pageData = this.pageData;
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getPlanList, {
                studentId: studentId,
                pageSize: pageData.pageSize,
                pageNumber: pageData.current
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let page = res.data.data.page;
                    this.planList = res.data.data.list;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }else{

                }
            })
        },
    }
}
</script>
<style scoped lang="less">
.recordList {
    background-color: #fff;
    padding: 20px 25px;
    min-height: 600px;
}
</style>